import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Header, Grid, Segment } from 'semantic-ui-react';
import api from '../../../api';
import QualitativeDetailsCollation from './QualitativeDetailsCollation';
import EstadisticasColocativos from './EstadisticasColocativos';

const headerStyle = { marginTop: '5px', marginBottom: '5px' };

class DetailsCollocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        Colocativo: {}
    };
  }

  componentDidMount = () => {
    const { match } = this.props;
    api.colocaciones
      .getOneCategory(match.params.colocacion,match.params.category,match.params.id)
      .then(Colocativo => this.setState({ Colocativo }));
  };

  render() {
    const { match } = this.props;

    return (
      <div>
        <Segment>
          <Header as="h2" icon textAlign="center" style={headerStyle}>
            <Header.Content>
              {(() => {
                if (match.params.clasification === '~ + adjetivo' || 
                match.params.clasification === '~ + verbo') {
                  return (
                    <>Colocación: <em>{match.params.colocacion}
                    &nbsp;{match.params.sintagma}</em></>
                  )
                } else if (match.params.clasification === 'verbo + ~') {
                  return (
                    <>Colocación: <em>{match.params.sintagma}
                    &nbsp;{match.params.colocacion}</em></>
                  )
                } else if (match.params.clasification === 'nombre de ~') {
                  return (
                    <>Colocación: <em>{match.params.sintagma} de&nbsp;
                    {match.params.colocacion}</em></>                    
                  )
                } else {
                  return (
                    <>Colocación: <em>{match.params.sintagma}</em></>
                  )
                }
              })()}
            </Header.Content>
          </Header>
        </Segment>
        <Grid columns="equal">
          <Grid.Column>
            <QualitativeDetailsCollation 
              lema={match.params.colocacion} 
              categoria={match.params.category} 
              clasificacion={match.params.clasification}
              id={match.params.id}
	      sintagma={match.params.sintagma}    
            />
          </Grid.Column>
          <Grid.Column>
            <Header as="h3" block attached="top" color="blue">
              Datos cuantitativos
            </Header>
            <Segment attached>
              <EstadisticasColocativos                  
                lema={match.params.colocacion} 
                categoria={match.params.sintagma} 
                clasificacion={match.params.clasification}
                id={match.params.id} 
                corpus={'Expertos'}
              />  
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

DetailsCollocation.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clasification: PropTypes.string.isRequired,
      colocacion: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired
    })
  }).isRequired 
};

export default withRouter(DetailsCollocation);
